import * as types from '../constants/StructureActionTypes'
import {env} from '../constants/Environment';

const USE_SNAPSHOTS = false;

export function load_sports (firestore) {
	return function(dispatch){
        //dispatch(start_loading_events());		
        return (new Promise((resolve, reject) => {				
				(async () => {
					const observer = firestore.collection('environments/' + env + '/programs/0/sport').onSnapshot((querySnapshot) => {
                        let sports = [];

                        querySnapshot.forEach(function(doc) {
                            sports.push(doc.data());
                        });

                        dispatch({
                            type: types.RECEIVE_SPORTS,
                            sports: sports
                        })

                        if(!USE_SNAPSHOTS)
                            observer();
                    });

                    resolve();
                })();
			}));
	}
}

export function load_categories (firestore, sportId) {
	return function(dispatch){
        //dispatch(start_loading_events());		
        return (new Promise((resolve, reject) => {				
				(async () => {
					const observer = firestore.collection('environments/' + env + '/programs/0/category-in-sport').where('sport.uid', '==', sportId).onSnapshot((querySnapshot) => {
                        let categories = [];

                        querySnapshot.forEach(function(doc) {
                            categories.push(doc.data());
                        });

                        dispatch({
                            type: types.RECEIVE_CATEGORIES,
                            sport: sportId,
                            categories: categories
                        })

                        if(!USE_SNAPSHOTS)
                            observer();
                    });

                    resolve();
                })();
			}));
	}
}

export function load_tournaments (firestore, cisId) {
	return function(dispatch){	
        return (new Promise((resolve, reject) => {				
				(async () => {
					const observer = firestore.collection('environments/' + env + '/programs/0/tournaments').where('category.category-in-sport-uid', '==', cisId).onSnapshot((querySnapshot) => {
                        let tournaments = [];

                        querySnapshot.forEach(function(doc) {
                            tournaments.push(doc.data());
                        });

                        dispatch({
                            type: types.RECEIVE_TOURNAMENTS,
                            cis: cisId,
                            tournaments: tournaments
                        })

                        if(!USE_SNAPSHOTS)
                            observer();
                    });

                    resolve();
                })();
			}));
	}
}

export function load_events (firestore, tournamentId) {
	return function(dispatch){	
        return (new Promise((resolve, reject) => {				
				(async () => {
					const observer = firestore.collection('environments/' + env + '/programs/0/oe').where('tournament.uid', '==', tournamentId).onSnapshot((querySnapshot) => {
                        let events = [];

                        querySnapshot.forEach(function(doc) {
                            events.push(doc.data());
                        });

                        dispatch({
                            type: types.RECEIVE_EVENTS,
                            tournament: tournamentId,
                            events: events
                        })

                        if(!USE_SNAPSHOTS)
                            observer();
                    });

                    resolve();
                })();
			}));
	}
}

export function select_sport(sportId){
    return {
        type: types.SELECT_SPORT,
        id: sportId
    }
};

export function select_category(categoryId){
    return {
        type: types.SELECT_CATEGORY,
        id: categoryId
    }
};

export function select_tournament(tournamentId){
    return {
        type: types.SELECT_TOURNAMENT,
        id: tournamentId
    }
};

export function select_event(eventId){
    return {
        type: types.SELECT_EVENT,
        id: eventId
    }
};